import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  text: {
    color: theme.palette.text.primary,
    paddingBottom: "0.7rem",
    [theme.breakpoints.down('sm')]: {
      fontSize: "1.8rem",
      paddingBottom: "0"
    }
  },
}));

const Title = ({ text }) => {
  const classes = useStyles();

  return (
    <Box mb={2}>
      <Typography variant="h1" component="h1" className={classes.text}>
        {text}
      </Typography>
    </Box>
  );
};

export default Title;
